module.exports = __webpack_public_path__ + "static/media/architectContentTwo.0807e224.png";